export default {
  data: '/portal/api/units',
  export: '/portal/api/units/export'
};
